import { CumulioDashboard } from '../models/dashboard.model';

export function resolvePromise<T extends CumulioDashboard>(dashboardComponent: T, requestId: string, data: unknown): void {
  if (dashboardComponent.promises[requestId]) {
    dashboardComponent.promises[requestId].resolve(data);
    delete dashboardComponent.promises[requestId];
  }
}

export function rejectPromise<T extends CumulioDashboard>(dashboardComponent: T, requestId: string, data: unknown): void {
  if (dashboardComponent.promises[requestId]) {
    dashboardComponent.promises[requestId].reject(data);
    delete dashboardComponent.promises[requestId];
  }
}
